import { useApiLoading } from 'react-reqq-lite';

import * as actions from './actions';
import * as c from './constants';

export const usePostContactUs = () => {
  const isApiLoading = useApiLoading(c.POST_CONTACT_US, 'post');
  const action = (params, cb) => actions.postContactUs(params, cb);

  return [isApiLoading, action];
};
